import React, { useEffect, useState, useCallback } from 'react'
import { RepairInventoryDataGrid } from './RepairInventoryDataGrid'
import { AddRepairInventoryPane } from './AddRepairInventoryPane'
import { useDispatch } from 'react-redux'
import * as components from '../../components'
import * as rest from '../../services'
import { showErrorToast } from '../../state/toasts'

export const RepairInventoryListPage = ({ defaultFilters }) => {
  const dispatch = useDispatch()
  const [gridData, setGridData] = useState({})
  const [getAPIResults, setGetAPIResult] = useState(null)
  const [hiddenRowKeys, setHiddenRowKeys] = useState([])
  const handleTableChange = (type, { page, sizePerPage }) => {
    const paginationFilters = {
      ...gridData,
      page: page,
      page_size: sizePerPage,
    }
    setGridData(paginationFilters)
  }
  const onFilter = (data) => {
    const searchFilters = data ? { ...data, page: 1 } : gridData
    setGridData({ ...searchFilters })
  }
  const getData = useCallback(
    (data) => {
      let finalPayload = { ...gridData, ...data, ...defaultFilters }
      setGetAPIResult(null)
      new rest.RepairInventoryService()
        .makeGetRequest(finalPayload)
        .then((response) => {
          setGetAPIResult(response)
        })
        .catch((errors) => {
          dispatch(showErrorToast('Error', errors.response.data))
        })
    },
    [dispatch, gridData]
  )
  useEffect(() => {
    // dispatch(getLists('SERIALIZABLE_INVENTORY_ITEM'))
    // dispatch(getLists('CONSIGNMENT_TYPE'))
    getData()
  }, [dispatch, getData])
  return !getAPIResults ? (
    <components.Loading />
  ) : (
    <>
      <RepairInventoryDataGrid
        handleTableChange={handleTableChange}
        onFilter={onFilter}
        getData={getData}
        hiddenRowKeys={hiddenRowKeys}
        results={getAPIResults.results}
        pageSize={getAPIResults.page_size}
        count={getAPIResults.count}
        current={getAPIResults.current}
        onDelete={(item) => {
          setHiddenRowKeys([...hiddenRowKeys, item.url])
             getData({}) // refresh data
        }}
      >
        <AddRepairInventoryPane
          onSubmit={(data) => {
            getData()
          }}
          title="Add Repair Inventory"
        />
      </RepairInventoryDataGrid>
    </>
  )
}
